var map = {
	"./ar-OM.json": 87084,
	"./availableLanguages.json": 37252,
	"./bg-BG.json": 18971,
	"./bn-IN.json": 3322,
	"./cs-CZ.json": 69174,
	"./da-DK.json": 67277,
	"./de-DE.json": 59699,
	"./el-GR.json": 37879,
	"./en-US.json": 19832,
	"./es-ES.json": 48389,
	"./es-MX.json": 6824,
	"./fi-FI.json": 48555,
	"./fr-FR.json": 37733,
	"./gu-IN.json": 51014,
	"./hi-FJ.json": 51112,
	"./hr-HR.json": 43637,
	"./hu-HU.json": 67251,
	"./id-ID.json": 24011,
	"./is-IS.json": 73925,
	"./it-IT.json": 38219,
	"./ja-JP.json": 62200,
	"./km-KH.json": 73714,
	"./kn-IN.json": 48765,
	"./ko-KR.json": 29010,
	"./lo-LA.json": 91886,
	"./lt-LT.json": 32537,
	"./lv-LV.json": 53133,
	"./ml.json": 87491,
	"./mr-IN.json": 60311,
	"./ms-MY.json": 71715,
	"./my-MM.json": 10169,
	"./ne-NP.json": 74420,
	"./nl-NL.json": 43593,
	"./no-NO.json": 4387,
	"./or.json": 93887,
	"./pl-PL.json": 95841,
	"./pt-PT.json": 78561,
	"./ro-RO.json": 95211,
	"./ru-RU.json": 68427,
	"./si-LK.json": 21676,
	"./sk-SK.json": 55673,
	"./sr-RS.json": 92581,
	"./sv-SE.json": 56330,
	"./sw-CG.json": 93233,
	"./ta-LK.json": 71925,
	"./te-IN.json": 6551,
	"./th-TH.json": 98345,
	"./tl-PH.json": 79617,
	"./tr-TR.json": 96869,
	"./uk-UA.json": 95267,
	"./ur-IN.json": 97999,
	"./vi-VN.json": 98710,
	"./zh-CN.json": 74138,
	"./zh-TW.json": 7614
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9533;